import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["collection", "year", "country"]

  fill() {
    const selectedOption = this.collectionTarget.selectedOptions[0]
    if (!selectedOption) return

    const year = selectedOption.dataset.year
    const country = selectedOption.dataset.country

    if (year && this.hasYearTarget) {
      this.yearTarget.value = year
    }

    if (country && this.hasCountryTarget) {
      this.countryTarget.value = country
    }
  }
}